export default {
  // 登录
  async logInAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/login.html', {
        account: payload.account,
        password: payload.password,
      });
      if (res.data.status === 1) {
        if (res.data.data.loginStatus === '2') {
          context.commit('CLEAR_USER');
          throw new Error('Your account has been disabled by the manager, feel free to contact us');
        }
        context.commit('cart/RESET_CART_LIST', true);
        context.commit('SET_USER', {
          data: res.data.data,
          save: payload.save,
          account: {
            account: payload.account,
            password: payload.password,
          },
        });
        await context.dispatch('cart/getCartListAsync');
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
        timeout: 5000,
      });
      return Promise.reject(error);
    }
  },
  // 退出登录
  async logOutAsync(context) {
    try {
      const res = await this.$http.post('/u/logout.html');
      if (res.data.status === 1) {
        context.commit('CLEAR_USER');
        context.commit('cart/RESET_CART_LIST', true);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 注册
  async registerAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/add_save_buyer.html', {
        email: payload.email,
        passwords: this.$md5(payload.passwords),
        numericCode: payload.numericCode,
      });
      if (res.data.status === 1) {
        context.commit('SET_USER', { data: res.data.data });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 国家
  async getCountriesAsync(context) {
    if (context.state.countries.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/ot/getCountry.html');
      if (res.data.status === 1) {
        context.commit('SET_COMPANIES', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 商品分类
  async getGoodsCagegoriesAsync(context) {
    if (context.state.categories.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/GoodsCate/lists.html');
      if (res.data.status === 1) {
        context.commit('SET_GOODS_CATEGORY', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 新闻列表
  async getNewsListAsync(context, payload) {
    if (context.state.newsList.status && payload.p === +context.state.newsList.data.p) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/n/lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_NEWS_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  async getNewsDetailAsync(context, payload) {
    try {
      const res = await this.$http.post('/n/detail.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.data);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 购物车
  // async getShoppingCartAsync(context) {
  //   if (context.state.shoppingCart.status) {
  //     return Promise.resolve(1);
  //   }
  //   try {
  //     const res = await this.$http.post('/c/lists.html');
  //     if (res.data.status === 1) {
  //       context.commit('SET_SHOPPING_CART', res.data.data);
  //       return Promise.resolve(res.data.status);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit('TOGGLE_SNACKBAR', {
  //       type: 'error',
  //       text: error.message,
  //     });
  //     return Promise.reject(error);
  //   }
  // },
  // 首页商品
  async getGoodsByTagAsync(context, payload) {
    if (
      context.state.tagGoods[payload.name].status
      && +context.state.tagGoods[payload.name].currentPage === payload.p
    ) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/sg/get_tagList.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_TAG_GOODS', {
          data: res.data.data,
          totalItem: res.data.totalItem,
          currentPage: res.data.currentPage,
          isMore: res.data.isMore,
          tag: payload.type,
          name: payload.name,
          status: res.data.status,
        });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 商品热搜
  async getHotSearchAsync(context) {
    try {
      const res = await this.$http.post('/k/lists.html');
      if (res.data.status === 1) {
        context.commit('SET_HOT_SEARCH', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // NewsLetter
  async addNewsLetterAsync(context, payload) {
    try {
      const res = await this.$http.post('/trade/addEmail.html', payload);
      if (res.data.status === 1) {
        context.commit('TOGGLE_SNACKBAR', {
          type: 'success',
          text: 'Success',
        });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // Feedback
  async addFeedbackAsync(context, payload) {
    try {
      const res = await this.$http.post('/trade/addFeedback.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 首页轮播
  async getBannerListAsync(context, payload) {
    if (context.state.bannerList.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/Ads/banners_ads_lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_BANNER_LIST', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 首页轮播
  async getAdListAsync(context, payload) {
    if (context.state.adList.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/Ads/other_ads_lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_AD_LIST', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 网站配置项
  async getWebConfigAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/webConfig.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_WEB_CONFIG', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 图片搜索
  async getGoodsByImgAsync(context, payload) {
    try {
      const res = await this.$http({
        url: '/searchImage.html',
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: payload,
      });
      if (res.data.status === 1) {
        context.commit('SET_SEARCH_IMAGE_GOODS', res.data.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // 上传图片
  async uploadImgSync(context, payload) {
    try {
      const res = await this.$http({
        url: '/g/upload_input_file.html',
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: payload,
      });
      if (res.data.status === 1) {
        return Promise.resolve(res.data.filePath);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      });
      return Promise.reject(error);
    }
  },
  // // 验证码
  // async getVerifyCodeAsync(context, payload) {
  //   try {
  //     const res = await this.$http.post('/in/verify_code.html', payload);
  //     if (res.data.status === 1) {
  //       return Promise.resolve(res.data.verify_code);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit('TOGGLE_SNACKBAR', {
  //       type: 'error',
  //       text: error.message,
  //     });
  //     return Promise.reject(error);
  //   }
  // },
  // // 上传附件
  // async uploadAttachmentAsync(context, payload) {
  //   try {
  //     const res = await this.$http({
  //       url: '/sy/upload_input_file.html',
  //       method: 'post',
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       data: payload,
  //     });
  //     if (res.data.status === 1) {
  //       return Promise.resolve(res.data.filePath);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit('TOGGLE_SNACKBAR', {
  //       type: 'error',
  //       text: error.message,
  //     });
  //     return Promise.reject(error);
  //   }
  // },
  // // 上传图片
  // async uploadImgAsync(context, payload) {
  //   try {
  //     const res = await this.$http({
  //       url: '/g/upload_img.html',
  //       method: 'post',
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       data: payload,
  //     });
  //     if (res.data.status === 1) {
  //       return Promise.resolve(res.data.picPath);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit('TOGGLE_SNACKBAR', {
  //       type: 'error',
  //       text: error.message,
  //     });
  //     return Promise.reject(error);
  //   }
  // },
  // // 批量上传图片
  // async uploadImgMultipleAsync(context, payload) {
  //   try {
  //     const res = await this.$http({
  //       url: '/g/upload_multiple_image.html',
  //       method: 'post',
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       data: payload,
  //     });
  //     if (res.data.status === 1) {
  //       return Promise.resolve(res.data.picPath);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit('TOGGLE_SNACKBAR', {
  //       type: 'error',
  //       text: error.message,
  //     });
  //     return Promise.reject(error);
  //   }
  // },
};
